import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import { selectEApplicationsQueryItems } from '../../../../../redux/e-applications/selector';
import ServiceComponent from '../components/service.component';
import { services } from '../../../../../redux/services/action';
import { selectServicesQueryItems } from '../../../../../redux/services/selector';

const ManagementService = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const serviceQuery = useSelector(selectServicesQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [
    selectServices,
    setSelectServices
  ] = useState<any>([])

  const fetchServiceQueryById = () => {
    dispatch(services.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configurations/services/query`, entity: 'services', jsonData: {

        Records: [
          {
            Id: 0
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    })




  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectServices({ ...selectServices, [fields[0]]: value });

  }
  useEffect(
    () => {

      fetchServiceQueryById()
      setIsLoading(false)

    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectServices(serviceQuery?.result?.items)
      }
    },
    [isQuery]
  )
  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    await dispatch(services.resetAction({ actionType: 'update' }))
    await dispatch(services.update({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configurations/services`, entity: 'services', jsonData: {

        Records: [
          selectServices
        ]

      }
    }))
      .then(() => {
        back()
      })
  }

  const back = () => {
    navigate('/management/configurations/services')
  }

  return (
    <>

      {isLoading ? <PageLoader /> :
        <ServiceComponent
          handleInnerFormChange={handleInnerFormChange}
          selectServices={selectServices}
          back={back}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )

}

export default ManagementService;